// @flow
import { creativityMediaModel } from '../../../../../services/creativityMediaModel'

const productImage = require('./complotGlass.jpg')
const allTwoEs = require('./creativity2.png')
const allTwoCa = require('./creativity2.png')
const allFourEs = require('./creativity2.png')
const allFourCa = require('./creativity2.png')
const catalogTwoEs = require('./creativity2.png')
const catalogTwoCa = require('./creativity2.png')
const catalogFourEs = require('./creativity2.png')
const catalogFourCa = require('./creativity2.png')

const model = creativityMediaModel({
  catalogID: 'glassware',
  allTwoEs,
  allTwoCa,
  allFourEs,
  allFourCa,
  catalogTwoEs,
  catalogTwoCa,
  catalogFourEs,
  catalogFourCa
})

type Params = {
  catalogID: string,
  numberOfColumns: number,
  language: string
}

export default {
  productImage,
  creativityMedia: (params: Params) =>
    model[params.catalogID][params.numberOfColumns][params.language]
}
